
import Typography from '@mui/material/Typography';


export const TextDrugRosuvastatin = () => {

return(
<div>
    
<Typography variant="h6" >
<br />


Statins are a class of prescription medicines that have been used for decades to lower low-density lipoprotein (LDL-C or "bad") cholesterol in the blood. 
Statins reduce cholesterol, prevent cardiovascular disease, and are among the most commonly prescribed
medications in the world. Medicines in the statin class include atorvastatin, fluvastatin, lovastatin, pitavastatin, pravastatin, rosuvastatin, and simvastatin.
<br /><br />

Statin-Associated Musculoskeletal Symptoms<br /><br />

Statin-associated musculoskeletal symptoms (SAMS) impact statin adherence and
ultimately can impede the long-term effectiveness of statin therapy.<br /><br />

There are several identified pharmacogenetic variants that impact statin disposition and adverse events during statin therapy. <br /><br />
SLCO1B1 encodes a transporter that facilitates the hepatic uptake of all statins.<br /><br /> 
ABCG2 encodes an efflux transporter (BCRP) that modulates the absorption and disposition of rosuvastatin. <br /><br />CYP2C9
encodes a phase I drug metabolizing enzyme responsible for the oxidation of some statins. Genetic variation in
each of these genes alters systemic exposure to statins (i.e., simvastatin, rosuvastatin, pravastatin, pitavastatin,
atorvastatin, fluvastatin, lovastatin), which can increase the risk for SAMS.
<br /><br />
POTENTIAL BENEFITS AND RISKS FOR THE PATIENT<br /><br />
Based on the highly prevalent use of statins, one potential benefit of preemptive SLCO1B1, ABCG2, and CYP2C9 testing may be a reduction in the incidence of SAMS, by identifying those
at significant risk and recommending a lower statin dose or an alternative statin with lower SAMS risk. While prospective data showing that prescribing based on genetic testing results alter
SAMS incidence are lacking, there are emerging data demonstrating an improvement in patients’ perceptions of statins, appropriate statin prescribing, neutral data on patient-reported
adherence, and mixed data on reducing LDL-cholesterol levels50,51 as other potential benefits of applying SLCO1B1 testing
to clinical practice.<br /><br />
A possible risk could be an error in genotyping. Because genotypes are lifelong test results, any such error could stay in the medical record for the life of the patient. An error in genotyping
could result in a decrease in statin dose that was not otherwise necessary and could result in inadequate lipid-lowering therapy. <br /><br />
However, this risk can be minimized by (i) monitoring to ensure that the appropriate LDL-cholesterol reduction is achieved for the intended statin intensity and (ii) using an alternative statin with a
similar statin intensity based on the recommendations.<br /><br />
Another potential risk is that a patient or provider may inappropriately stop or avoid statin therapy, and this could cause higher LDL-cholesterol and increased cardiovascular risk.<br /><br /><br /><br />

CAVEATS: APPROPRIATE USE AND/OR POTENTIAL MISUSE OF GENETIC TESTS<br /><br />
As with any diagnostic test, genetic variation is just one factor that
clinicians should consider when prescribing statins. Furthermore,
rare variants may not be included in the genotype test used, and
patients with rare variants that reduce SLCO1B1 function may
be incorrectly assigned a normal phenotype based on a default to
wild-type (*1) test result.<br /><br />
In summary, statins are a powerful class of medications for
lowering LDL cholesterol and cardiovascular risk with an established track record of safety and efficacy. However, statinrelated musculoskeletal symptoms are the most frequently cited
reason for discontinuing statin therapy. Although clinicians are
well-tuned to trial stopping and later reinitiating statin therapy
in those who develop SAMS, in many patients statin therapy is
never restarted. As a result, LDL cholesterol values are higher
as is their risk for cardiovascular disease. We applied a rigorous
approach evaluating the collective evidence around SLCO1B1,
ABCG2, and CYP2C9 on systemic drug exposure and risk of
SAMS. Our evidenced-based recommendations for genotypeguided statin therapy are focused on reducing the risk of SAMS.
Based on this foundation, future research can evaluate the extent to which implementation of these guidelines impacts prescribing, SAMS risk, statin adherence, LDL cholesterol levels,
and risk for cardiovascular events in patients prescribed statin
therapy.<br /><br />



Sources: <br /><br />
https://cpicpgx.org/guidelines/cpic-guideline-for-statins/<br />
The Clinical Pharmacogenetics Implementation Consortium Guideline for SLCO1B1, ABCG2, and CYP2C9 genotypes and Statin-Associated Musculoskeletal Symptoms<br /><br />
https://api.cpicpgx.org/v1/<br /> 
https://medlineplus.gov/druginfo/ <br /> 
https://www.pharmgkb.org/pathway/PA145011109 

</Typography>

</div>

)
}